import slick from 'script-loader!./../../node_modules/slick-carousel/slick/slick.min.js';

jQuery(document).ready(function($){
    $('.cta-bar').slick({
        slidesToShow: 4,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    centerMode: false,
                    slidesToShow: 3,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    dots: true
                }
            }
        ]
    });
}); 